module.exports = __webpack_public_path__ + "img/18.cab0b750.png";